//* project imports
import { AlertProps, alpha, Palette, PaletteColor, Theme } from '@mui/material';
import { ThemeMode } from 'config';

export default function Alert(theme: Theme) {
  return {
    MuiAlert: {
      styleOverrides: {
        root: {
          alignItems: 'center',
          variants: [
            {
              props: { variant: 'standard' },
              style: ({ ownerState }: { ownerState: AlertProps }) => {
                const paletteColor = theme.palette[ownerState.severity as keyof Palette] as PaletteColor;

                return {
                  ...(paletteColor && {
                    color: paletteColor.main,
                    backgroundColor:
                      theme.palette.mode === ThemeMode.DARK
                        ? alpha(paletteColor.dark, 0.15)
                        : alpha(paletteColor.light, 0.5),
                    ...(ownerState.severity === 'info' && {
                      backgroundColor:
                        theme.palette.mode === ThemeMode.DARK
                          ? alpha(paletteColor.dark, 0.15)
                          : alpha(paletteColor.light, 0.15),
                    }),
                    ...(ownerState.severity === 'error' && {
                      backgroundColor:
                        theme.palette.mode === ThemeMode.DARK
                          ? alpha(paletteColor.dark, 0.15)
                          : alpha(paletteColor.light, 0.2),
                    }),
                    ...(ownerState.severity === 'success' && {
                      backgroundColor:
                        theme.palette.mode === ThemeMode.DARK
                          ? alpha(paletteColor.dark, 0.15)
                          : alpha(paletteColor.light, 0.25),
                    }),
                    ...((ownerState.severity === 'warning' || ownerState.severity === 'success') && {
                      color: theme.palette.mode === ThemeMode.DARK ? paletteColor.main : paletteColor.dark,
                    }),
                  }),
                };
              },
            },
          ],
        },
        outlined: {
          border: '1px dashed',
        },
      },
    },
  };
}
